import { usePostHog } from "posthog-js/react";

export function useTrackClickHintView() {
  const posthog = usePostHog();

  const trackClickHintView = () => {
    posthog.capture("click_hint_viewed");
  };

  return trackClickHintView;
} 